// engine
import { ArController } from '@aceroll/core';

export class RoundStart extends ArController {
    onStart() {
        this.stop();
    }
}